module.exports = __webpack_public_path__ + "static/move_heatmap_monthly-1540815d0da27a768dda04b681ad5b9b.jpg";